module.exports = __webpack_public_path__ + "img/clairvoyance.345b9b22.png";